import FilterGroup from "@/components/feature/FilterGroup";

export interface CategoryFilterState {
  ages: string[];
  debuts: string[];
  statuses: string[];
  agencies: string[];
}

interface CategoryFiltersProps {
  state: CategoryFilterState;
  onToggle: (key: keyof CategoryFilterState, value: string) => void;
  onReset: () => void;
  ageOptions: { value: string; label: string; count: number }[];
  debutOptions: { value: string; label: string; count: number }[];
  statusOptions: { value: string; label: string; count: number }[];
  agencyOptions: { value: string; label: string; count: number }[];
}

export default function CategoryFilters({
  state,
  onToggle,
  onReset,
  ageOptions,
  debutOptions,
  statusOptions,
  agencyOptions,
}: CategoryFiltersProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-1.5 font-heading text-sm font-bold text-foreground-950">
          <i className="ri-equalizer-line text-primary-600" aria-hidden="true"></i>
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="cursor-pointer font-label text-[11px] text-foreground-500 transition-colors hover:text-primary-700"
        >
          全部重置
        </button>
      </div>
      <div className="space-y-4">
        <FilterGroup
          title="年龄段"
          icon="ri-user-line"
          options={ageOptions}
          selected={state.ages}
          onToggle={(value) => onToggle("ages", value)}
        />
        <FilterGroup
          title="出道年份"
          icon="ri-calendar-line"
          options={debutOptions}
          selected={state.debuts}
          onToggle={(value) => onToggle("debuts", value)}
        />
        <FilterGroup
          title="活跃状态"
          icon="ri-pulse-line"
          options={statusOptions}
          selected={state.statuses}
          onToggle={(value) => onToggle("statuses", value)}
        />
        <FilterGroup
          title="所属事务所"
          icon="ri-building-line"
          options={agencyOptions}
          selected={state.agencies}
          onToggle={(value) => onToggle("agencies", value)}
        />
      </div>
      <p className="mt-4 rounded-md bg-background-100 px-3 py-2 font-label text-[10px] leading-relaxed text-foreground-500">
        多个条件之间为「同时满足」关系，同一条件内可多选。筛选结果会实时刷新并重置到第一页。
      </p>
    </div>
  );
}